import React, { ReactNode } from 'react';
import { Section } from '../section/section.comp';
import { StyledDiv } from './longCopy.styles';

interface ILongCopyProps {
    title: string;
    children: ReactNode;
}

export const LongCopy = ({ title, children }: ILongCopyProps) => {
    return (
        <Section>
            <StyledDiv>
                <h1>{title}</h1>
                <div className="text-wrapper">
                    {children}
                </div>
            </StyledDiv>
        </Section>
    );
};
